<template>
  <div>
    <v-dialog
      :value="value"
      :max-width="maxWidth"
      scrollable
      persistent
      no-click-animation
      @click:outside="requestClose"
      @keydown.esc="requestClose"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center flex-nowrap py-3">
          <span class="text-h6 font-weight-bold">{{ title }}</span>
          <v-btn icon aria-label="關閉視窗" @click="requestClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pt-4 pb-5 black--text">
          <slot/>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="px-6 py-3">
          <v-spacer/>
          <v-btn outlined color="grey darken-1" :disabled="saving" @click="requestClose">取消</v-btn>
          <slot name="submit"/>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm-dialog
      v-if="leaveConfirm"
      v-model="leaveConfirm"
      title="尚未儲存的變更會消失，確定要關閉嗎？"
      confirm-btn-text="確定關閉"
      cancel-btn-text="繼續編輯"
      @confirm="$emit('input', false)"
    />
  </div>
</template>

<script>
import ConfirmDialog from "@/components/utils/ConfirmDialog.vue";

export default {
  name: "SlotClosureDialogShell",

  components: {ConfirmDialog},

  props: {
    value: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    maxWidth: {
      type: [String, Number],
      default: 720
    },
    dirty: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      leaveConfirm: false
    }
  },

  methods: {
    requestClose() {
      if (this.saving) return
      if (this.dirty) {
        this.leaveConfirm = true
      } else {
        this.$emit('input', false)
      }
    }
  }
}
</script>
